import AppWarn from '../errors/app-warns'
import http from '../webhook/httpconfig'
import { cancelHTTPRequests } from '@/services/utils'
import { generateHeaders } from '../webhook/webhook'

export async function getUrlData(payload) {
  let urlDetails = {}
  try {
    const response = await http.request({
      method: 'post',
      url: `/api/urlDetails`,
      data: payload,
      headers: generateHeaders(),
      cancelToken: cancelHTTPRequests()
    })
    urlDetails = response.data?.payload
  } catch (err) {
    throw new AppWarn({name: 'Get NBA URls info', message:`Error while fetching urls. ${err.message}`})
  }
  return urlDetails
}


